import {API_URL} from "@/shared/lib/api";
import {PaymDocTableInterface} from "@/features/types/PaymDocTableInterface";

/**
 * Pobiera wiersze tabeli opłat/zaliczek (PaymDoc) dla danego zamówienia.
 * Backend: action=paym-doc-table, body: { f_ord_num, f_ord_d }.
 */
export async function getPaymDocTableData(
    f_ord_num: string,
    f_ord_d: string
): Promise<PaymDocTableInterface[]> {
    const res = await fetch(`${API_URL}/index.php?action=paym-doc-table`, {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        credentials: "include",
        body: JSON.stringify({f_ord_num, f_ord_d}),
    });

    if (!res.ok) throw new Error(`HTTP error! Status: ${res.status}`);
    return await res.json();
}
